/**
 * 3D Model Viewer — modal expand + preset panel
 * Config injected via window.ModelViewer3DConfig[sectionId]
 */
(function () {
  'use strict';

  window.ModelViewer3D = window.ModelViewer3D || {};

  // Lazy-load model-viewer library only when modal first opens
  function loadModelViewerScript() {
    if (window.modelViewerScriptLoaded) return;
    window.modelViewerScriptLoaded = true;
    const s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
    document.head.appendChild(s);
  }

  function getConfig(sectionId) {
    return (window.ModelViewer3DConfig && window.ModelViewer3DConfig[sectionId]) || {};
  }

  /* ---- Camera helpers ---- */
  function logCameraValues(mv, label) {
    console.group('3D Model Camera — ' + (label || mv.id));
    try {
      console.log('Live orbit :', mv.getCameraOrbit ? mv.getCameraOrbit() : 'n/a');
      console.log('Live target:', mv.getCameraTarget ? mv.getCameraTarget() : 'n/a');
      console.log('Live FOV   :', mv.getFieldOfView ? mv.getFieldOfView() : 'n/a');
    } catch (e) {}
    console.log('cameraOrbit :', mv.cameraOrbit);
    console.log('cameraTarget:', mv.cameraTarget);
    console.log('fieldOfView :', mv.fieldOfView);
    console.groupEnd();
  }

  function initCameraLogging(mv) {
    ['load', 'camera-change', 'mouseup', 'touchend', 'wheel'].forEach(function (evt) {
      mv.addEventListener(evt, function () { setTimeout(function () { logCameraValues(mv); }, 100); });
    });
    setTimeout(function () { logCameraValues(mv, 'initial'); }, 2000);
    console.info('[3D Model Viewer] Camera logging ON — use window.logAllMV3DCameras()');
  }

  window.logAllMV3DCameras = function () {
    document.querySelectorAll('model-viewer[id^="s-3d-mv-"]').forEach(function (mv) { logCameraValues(mv); });
  };

  // Parse console-pasted orbit: {theta: X, phi: Y, radius: Z} → 'Xrad Yrad Zm'
  // Falls through unchanged if already in model-viewer format.
  function parseOrbit(str) {
    str = String(str || '').trim();
    var theta = str.match(/theta\s*:\s*([-\d.eE+]+)/);
    var phi   = str.match(/phi\s*:\s*([-\d.eE+]+)/);
    var rad   = str.match(/radius\s*:\s*([-\d.eE+]+)/);
    if (theta && phi && rad) {
      return parseFloat(theta[1]) + 'rad ' + parseFloat(phi[1]) + 'rad ' + parseFloat(rad[1]) + 'm';
    }
    return str;
  }

  // Parse console-pasted target: {x: X, y: Y, z: Z} → 'Xm Ym Zm'
  function parseTarget(str) {
    str = String(str || '').trim();
    var x = str.match(/\bx\s*:\s*([-\d.eE+]+)/);
    var y = str.match(/\by\s*:\s*([-\d.eE+]+)/);
    var z = str.match(/\bz\s*:\s*([-\d.eE+]+)/);
    if (x && y && z) {
      return parseFloat(x[1]) + 'm ' + parseFloat(y[1]) + 'm ' + parseFloat(z[1]) + 'm';
    }
    return str;
  }

  function applyCamera(mv, orbit, target, fov) {
    mv.cameraOrbit  = parseOrbit(orbit);
    mv.cameraTarget = parseTarget(target);
    mv.fieldOfView  = fov + 'deg';
  }

  // Normalize model-viewer HTML attributes so the library reads correct values
  function normalizeModelViewerAttrs(mv) {
    var orbit = mv.getAttribute('camera-orbit');
    var target = mv.getAttribute('camera-target');
    if (orbit) mv.setAttribute('camera-orbit', parseOrbit(orbit));
    if (target) mv.setAttribute('camera-target', parseTarget(target));
    if (mv.dataset.defaultOrbit) mv.dataset.defaultOrbit = parseOrbit(mv.dataset.defaultOrbit);
    if (mv.dataset.defaultTarget) mv.dataset.defaultTarget = parseTarget(mv.dataset.defaultTarget);
  }

  // Replace the radius (3rd component) of an orbit string with radiusMeters
  function setOrbitRadius(orbit, radiusMeters) {
    var parts = (orbit || '').trim().split(/\s+/);
    if (parts.length >= 3) parts[2] = radiusMeters.toFixed(3) + 'm';
    return parts.join(' ');
  }


  function applyDefaultCamera(sectionId) {
    const mv = document.getElementById('s-3d-mv-' + sectionId);
    if (!mv) return;
    applyCamera(
      mv,
      mv.dataset.defaultOrbit  || mv.getAttribute('camera-orbit'),
      mv.dataset.defaultTarget || mv.getAttribute('camera-target'),
      mv.dataset.defaultFov    || mv.getAttribute('field-of-view')
    );
    if (getConfig(sectionId).cameraLogging) logCameraValues(mv, 'default restored');
  }

  /* ---- Preset card activation ---- */
  function activatePreset(sectionId, index) {
    const modal = document.getElementById('s-3d-mv-modal-' + sectionId);
    const mv    = document.getElementById('s-3d-mv-' + sectionId);
    if (!modal || !mv) return;

    // Mark active card
    modal.querySelectorAll('.s-3d-mv-preset-card').forEach(function (c) {
      c.classList.remove('s-3d-mv-preset-card--active');
    });

    const card = document.getElementById('s-3d-mv-preset-' + sectionId + '-' + index);
    if (card) {
      card.classList.add('s-3d-mv-preset-card--active');
      var orbit = parseOrbit(card.dataset.orbit);  // normalize before any radius swap
      if (card.dataset.zoom) {
        orbit = setOrbitRadius(orbit, parseInt(card.dataset.zoom, 10) / 100);
      }
      applyCamera(mv, orbit, card.dataset.target, card.dataset.fov);
      if (getConfig(sectionId).cameraLogging) logCameraValues(mv, 'preset ' + index);
    }
  }

  /* ---- Modal open / close ---- */
  function openModal(sectionId) {
    const modal = document.getElementById('s-3d-mv-modal-' + sectionId);
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Normalize any console-pasted orbit/target values before model-viewer reads them
    var mv = document.getElementById('s-3d-mv-' + sectionId);
    if (mv) normalizeModelViewerAttrs(mv);

    loadModelViewerScript();

    // Focus close button after transition
    const closeBtn = modal.querySelector('.s-3d-mv-modal__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);

    // Escape key handler
    modal._keyHandler = function (e) {
      if (e.key === 'Escape') closeModal(sectionId);
    };
    document.addEventListener('keydown', modal._keyHandler);
  }

  function closeModal(sectionId) {
    const modal = document.getElementById('s-3d-mv-modal-' + sectionId);
    if (!modal) return;

    // Clear active state & restore default camera
    modal.querySelectorAll('.s-3d-mv-preset-card--active').forEach(function (c) {
      c.classList.remove('s-3d-mv-preset-card--active');
    });
    applyDefaultCamera(sectionId);

    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (modal._keyHandler) {
      document.removeEventListener('keydown', modal._keyHandler);
      modal._keyHandler = null;
    }
  }

  /* ---- Section init ---- */
  function initSection(sectionId) {
    if (!getConfig(sectionId).cameraLogging) return;
    const mv = document.getElementById('s-3d-mv-' + sectionId);
    if (mv) { initCameraLogging(mv); return; }
    const observer = new MutationObserver(function () {
      const el = document.getElementById('s-3d-mv-' + sectionId);
      if (el) { observer.disconnect(); initCameraLogging(el); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Public API (kept for Theme Editor compatibility)
  window.ModelViewer3D.openModal      = openModal;
  window.ModelViewer3D.closeModal     = closeModal;
  window.ModelViewer3D.activatePreset = activatePreset;
  window.ModelViewer3D.initSection    = initSection;

  // Event delegation — works regardless of inline onclick / load order
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mv3d-open]');
    if (openBtn) { openModal(openBtn.getAttribute('data-mv3d-open')); return; }

    var closeBtn = e.target.closest('[data-mv3d-close]');
    if (closeBtn) { closeModal(closeBtn.getAttribute('data-mv3d-close')); return; }

    var presetBtn = e.target.closest('[data-mv3d-preset]');
    if (presetBtn) {
      activatePreset(
        presetBtn.getAttribute('data-mv3d-preset'),
        parseInt(presetBtn.getAttribute('data-mv3d-preset-index'), 10)
      );
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    // Teleport modals to <body> so position:fixed isn't trapped by a
    // transformed/filtered ancestor (e.g. Shopify's shopify-section wrapper
    // or animate-on-scroll transforms).
    document.querySelectorAll('.s-3d-mv-modal').forEach(function (modal) {
      document.body.appendChild(modal);
    });
    Object.keys(window.ModelViewer3DConfig || {}).forEach(initSection);
  });
})();
